import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";

export interface DeleteProductUnitDTO {
  productNumber: number | undefined;
}

export type DeleteProductUnitResp = BaseResAPI<null>;

const deleteProductUnitInteractor = (
  params: DeleteProductUnitDTO
): Promise<DeleteProductUnitResp> => {
  const { productNumber } = params;
  const path = `/admin/stock/${productNumber}`;
  return api.delete(path);
};

export default deleteProductUnitInteractor;
